import ApiBase from './Api'
import {
    CustomerListQueryParameters,
    GetCustomerByIdRequest,
    GetCustomerListRequest,
    PostCustomerRequest,
    PutCustomerRequest,
} from '@finance-lab/utils/types'

const ADMIN_CUSTOMER_API_PATHS = {
    ALL_CUSTOMERS: '/admin/customers',
    CUSTOMER_DETAILS: (id: string) => `/admin/customers/${id}`,
    UPDATE_CUSTOMER: (id: string) => `/admin/customers/${id}`,
}

export type AdminFindCustomersParams = Omit<CustomerListQueryParameters, 'page' | 'limit'> & {
    paginationModel: { page: number; pageSize: number }
}

class CustomerApi extends ApiBase {
    adminFindCustomers({ paginationModel, ...filters }: AdminFindCustomersParams) {
        return this._getRequest<GetCustomerListRequest>(ADMIN_CUSTOMER_API_PATHS.ALL_CUSTOMERS, {
            queryParameters: {
                ...filters,
                page: paginationModel.page,
                limit: paginationModel.pageSize,
            },
        })
    }

    async createCustomer(name: string) {
        return this._postRequest<PostCustomerRequest>(ADMIN_CUSTOMER_API_PATHS.ALL_CUSTOMERS, { name })
    }

    getCustomer(id: string) {
        return this._getRequest<GetCustomerByIdRequest>(ADMIN_CUSTOMER_API_PATHS.CUSTOMER_DETAILS(id))
    }

    async updateCustomer(id: string, data: PutCustomerRequest['Body']) {
        return this._putRequest<PutCustomerRequest>(`${ADMIN_CUSTOMER_API_PATHS.UPDATE_CUSTOMER(id)}`, data)
    }
}

export default CustomerApi
